import { render, staticRenderFns } from "./C1D.vue?vue&type=template&id=f90b749a"
import script from "./C1D.vue?vue&type=script&lang=js"
export * from "./C1D.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports